import axios from 'axios'
import { snackBarBus } from '../main'
import { generalMixin } from './general'
import { urlMixin } from '../mixins/url'
import { mapGetters } from 'vuex'

export const downloadMixin = {
  mixins: [generalMixin, urlMixin],
  computed: {
    ...mapGetters(['access_token']),
  },
  methods: {
    download_forceFileDownload(fileData) {
      /*
      let headers = response.headers;
      const data = response.data; // or res.blob() if using blob responses
      let blob = new Blob(
        [data],
        {
          type: headers['content-type']
        }
      );
      let blob_1 = new Blob(
        [data],
      );
      console.log('blob', blob)
      console.log('blob_1', blob_1)
      const url = window.URL.createObjectURL(blob)
      */

      const link = document.createElement('a')
      link.setAttribute('download', fileData.name);
      link.href = fileData.url
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    download_downloadDataTable(fileLabel, dataTable) {
      console.log('dataTable', dataTable)
      const computedItems = dataTable.$children[0].computedItems
      console.log('computedItems', computedItems)
      const hasFilteredView = dataTable.items.length > computedItems.length
      console.log('hasFilteredView', hasFilteredView)
      if (computedItems.length == 0) {
        snackBarBus.$emit('message', 'Inga rader att exportera')
        return
      }
      let ids = hasFilteredView ? computedItems.map(item => item.id) : []
      this.download_downloadFile(fileLabel, ids)
    },
    download_downloadFile(fileLabel, ids) {
      //set config for axios request with Authorization header
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      //post data to API
      let postData = {
        ids: ids
      }
      let url = this.url_composeApiUrl('/download/' + fileLabel)
      console.log('post: ' + url, postData)
      axios.post(url, postData, config)
        .then(response => {
          console.log('response', response)
          if (response.data.success) {
            //success
            this.download_forceFileDownload(response.data.returnData.fileData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    }  
  }
}
